module.exports = __webpack_public_path__ + "static/media/cent-collected.a54c1d11.png";